import { render, staticRenderFns } from "./PacientesAntecedentesHeredofamiliares.vue?vue&type=template&id=09ee5239"
import script from "./PacientesAntecedentesHeredofamiliares.vue?vue&type=script&lang=js"
export * from "./PacientesAntecedentesHeredofamiliares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports